import React from 'react';

const IconAngleRight: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4652 12.0001L7.0144 4.52435C6.72484 4.2682 6.69776 3.82582 6.95391 3.53626C7.21006 3.24669 7.65245 3.21961 7.94201 3.47576L16.9855 11.4758C17.3004 11.7544 17.3004 12.2458 16.9855 12.5244L7.94201 20.5244C7.65245 20.7805 7.21006 20.7534 6.95391 20.4639C6.69776 20.1743 6.72484 19.7319 7.0144 19.4758L15.4652 12.0001Z"
      fill="currentColor"
    />
  </svg>
);

export default IconAngleRight;
